var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFitToWidth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M8 37.4v-10c0-3.1 2.5-5.7 5.7-5.7h15.2c3.1 0 5.7 2.5 5.7 5.7v10M34.5 5.7v5.5M28.6 16.6h-15C10.5 16.6 8 14 8 10.9V5.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M14.6 35.4l-3.1-3 3-3.1M12.5 32.4l4.9-.1M28.1 29.2l3 3-2.9 3.1M30.2 32.2l-5.1.1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 21.4,
    cy: 32.3,
    r: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitToWidth);
export default __webpack_public_path__ + "static/media/fitToWidth.1e1429071df558be2a1ffdfa49bb4c7b.svg";
export { ForwardRef as ReactComponent };